var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "spinner spinner--socker", style: _vm.styles },
    [
      _c("div", { staticClass: "spinner-inner", style: _vm.innerStyles }, [
        _c(
          "div",
          { staticClass: "cube panelLoad" },
          _vm._l(_vm.faces, function ({ side, letter }) {
            return _c(
              "div",
              { key: side, class: `cube-face cube-face-${side}` },
              [_vm._v(_vm._s(letter))]
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }